module.exports = __webpack_public_path__ + "static/media/em-97.4069f532.png";